import React, { useState } from 'react';
import { Checkbox } from 'semantic-ui-react';
import styled from 'styled-components';
import { QuestionHeader, QuestionIndex, QuestionStatement } from '../../components';
import QuestionContainer from './QuestionContainer';

const Choice = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: #f6e9db;
  border: 1px solid #f6e9db;
  cursor: pointer;

  label {
    font-family: 'IBM Plex Sans';
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #2e2d29;
    cursor: pointer;
  }
  &.checked {
    background: #f9a44a;
    border: 1px solid #f9a44a;
    label {
      font-weight: 700;
      color: #ffffff;
    }
  }
  &.disabled {
    pointer-events: none;
  }
`;

const CheckboxWrapper = styled(Checkbox)`
  background: #f6e9db !important;
  border: 1px solid #f6e9db !important;
  margin-right: 15px !important;

  label:before {
    background: #f6e9db !important;
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #2e2d29 !important;
    border-radius: 2px !important;
  }
  label:hover:before {
    border-color: #2e2d29 !important;
    background: #f6e9db !important;
  }

  &.checked {
    background: #f9a44a !important;
    border: 1px solid #f9a44a !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    label:before {
      border-color: #ffffff !important;
      background: #f9a44a !important;
    }
    label:after {
      color: #ffffff !important;
      font-size: 12px;
      top: -1px;
      font-weight: normal;
      width: 18px !important;
      height: 18px !important;
    }
    label:focus::before {
      border-color: #ffffff !important;
      background: #f9a44a !important;
    }
  }
`;

const MultiSelectQuestion = ({ index, statement, options, disabled, onClick }) => {
  const [selected, setSelected] = useState([]);

  const handleToggle = option => {
    if (disabled) return;
    let updated;
    if (selected.includes(option)) {
      updated = selected.filter(v => v !== option);
    } else {
      updated = [...selected, option];
    }
    setSelected(updated);
    onClick(updated.length > 0 ? updated : []);
  };

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionIndex>{`Question ${index + 1}`}</QuestionIndex>
        <QuestionStatement>{statement}</QuestionStatement>
      </QuestionHeader>
      <div className="mt3">
        {options.map((option, i) => (
          <Choice
            key={i}
            className={`col-9 mt2 px3 py2 ${selected.includes(option) ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => handleToggle(option)}
          >
            <CheckboxWrapper
              type="checkbox"
              value={option}
              checked={selected.includes(option)}
              disabled={disabled}
              onChange={() => {}}
            />
            <label>{option}</label>
          </Choice>
        ))}
      </div>
    </QuestionContainer>
  );
};

export default MultiSelectQuestion;
